<template>
  <component :is="footerComponent"></component>
</template>

<script>
import WSDFooter from '../FooterParticipant.vue'
import FooterMeekijken from '../meekijken/FooterParticipant.vue'

export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  components: {
    WSDFooter,
    FooterMeekijken
  },
  computed: {
    footerComponent () {
      return this.$store.getters.getProductMode === 'WSD' ? WSDFooter : FooterMeekijken
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
